import { Component, OnDestroy, ViewChild } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Subscription } from 'rxjs';
import { CommonModule } from '@angular/common';
import { SidebarService } from '../../services/sidebar/sidebar.service';
import { JwtTokenService } from '../../services/jwt-token/jwt-token.service';
import { ReportTypeSelectorComponent } from '../../../shared/components/report-type-selector/report-type-selector.component';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [RouterModule, ReportTypeSelectorComponent, CommonModule],
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css'],
})
export class SidebarComponent implements OnDestroy {
  isCollapsed = false;
  private readonly sidebarSubscription: Subscription;

  @ViewChild(ReportTypeSelectorComponent)
  reportTypeSelector!: ReportTypeSelectorComponent;

  constructor(
    private readonly sidebarService: SidebarService,
    private readonly jwtTokenService: JwtTokenService,
  ) {
    this.sidebarSubscription = this.sidebarService.sidebarState$.subscribe(
      (isCollapsed) => {
        this.isCollapsed = isCollapsed;
      },
    );
  }

  ngOnDestroy() {
    if (this.sidebarSubscription) {
      this.sidebarSubscription.unsubscribe();
    }
  }

  get userRole(): string {
    return this.jwtTokenService.getFormattedRole() || 'Usuário';
  }

  openReportTypeModal(event: Event): void {
    event.preventDefault();
    if (this.reportTypeSelector) {
      this.reportTypeSelector.openModal();
    }
  }
}
